import React, {useEffect} from 'react';
import springboard from 'springboard';
import usertour from 'usertour.js';
import {useCurrentUser} from '../music_sniper/hooks/useCurrentUser';

// @ts-ignore
import {deserialize, serialize} from '@ungap/structured-clone';
globalThis.structuredClone ??= (value, options) => {
    return deserialize(serialize(value, options));
};

(window as any).USERTOURJS_ENV_VARS = {
    WS_URI: 'https://tour.songdrive.app',
    ASSETS_URI: 'https://tour.songdrive.app/sdk',
    USERTOURJS_ES2020_URL: 'https://tour.songdrive.app/sdk/es2020/usertour.js',
    USERTOURJS_LEGACY_URL: 'https://tour.songdrive.app/sdk/legacy/usertour.iife.js',
};

springboard.registerModule('UserTour', {}, async (moduleAPI) => {
    let firstEffect = true;
    return;

    return {
        Provider: (props: React.PropsWithChildren) => {
            const currentUser = useCurrentUser();
            useEffect(() => {
                (async () => {
                    if (firstEffect) {
                        firstEffect = false;
                        await usertour.load();
                        usertour.init(process.env.USERTOUR_TOKEN!);
                        usertour.setCustomNavigate(url => (window as any).spaNavigate(url));
                    }

                    if (process.env.IS_DEMO_SITE === 'true') {
                        usertour.identifyAnonymous({
                            is_demo: true,
                        });
                    } else if (currentUser) {
                        usertour.identify(currentUser.id, {
                            user_id: currentUser.id,
                            name: currentUser.name,
                            is_demo: false,
                            created_at: currentUser.created_at,
                            site: process.env.PUBLIC_SITE_URL,
                        });
                    }
                })();
            }, [currentUser]);

            return props.children;
        },
    }
});
